import React, { useEffect, useState } from 'react';
import api from '../api/api';

export default function Applications() {
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    api.get('/applications/received')
      .then((res) => setApplications(res.data))
      .catch(() => alert('Error al obtener postulaciones.'));
  }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/applications/${id}`, { status });
      alert('Estado actualizado');
      setApplications((prev) =>
        prev.map((a) => (a.id === id ? { ...a, status } : a))
      );
    } catch {
      alert('Error al actualizar estado');
    }
  };

  return (
    <section className="applications-section">
      <h2>Postulaciones recibidas</h2>
      {applications.map((a) => (
        <div key={a.id} className="application-card">
          <h3>{a.task_title}</h3>
          <p>Trabajador: {a.worker_name}</p>
          <p>Estado: {a.status}</p>
          <button onClick={() => updateStatus(a.id, 'aceptada')}>Aceptar</button>
          <button onClick={() => updateStatus(a.id, 'rechazada')}>Rechazar</button>
        </div>
      ))}
    </section>
  );
}
